import { ArrowUpNarrowWide, ArrowDownWideNarrow, ArrowUpDown } from "lucide-react";

const SortIcons = ({ field, sortConfig }) => {
  const isActiveAsc = sortConfig.field === field && sortConfig.direction === "asc";
  const isActiveDesc = sortConfig.field === field && sortConfig.direction === "desc";

  return (
    <span className="d-flex ms-sm-2 ms-md-4 ms-lg-5">
      {isActiveAsc && <ArrowUpNarrowWide className="text-success"  />}
      {isActiveDesc && <ArrowDownWideNarrow className="text-danger"  />}
      {!isActiveAsc && !isActiveDesc && <ArrowUpDown className="text-primary-600"  />}
    </span>
  );
};

export default SortIcons;